import React from "react";
import "./index.scss";

const GUIButton = ({imgUrl, onClickFunc, option, children}) => {
  return (
    <button className={`gui-button ${option}`} onClick={onClickFunc}>
      {children || <img src={imgUrl} className="gui-button-icon" />}
    </button>
  );
};

export default GUIButton;
